import { useEffect, useMemo } from "react";
import { useProjectActions, useProjectContext } from "@contexts/projects";
import { buildProjectionRequestKey } from "@contexts/projects/projectionScope";
import ProjectionLoadState from "@components/dashboard/financialProjection/ProjectionLoadState";
import SubstepAccordion from "./SubstepAccordion";
import AccordionItem from "./AccordionItem";

const StepAccordion = ({ parent, parentLabel, filters, path = [], containerId }) => {
  const { activeProject: { _id, steps = {} }, projectionLoads = {} } = useProjectContext();
  const { loadSteps } = useProjectActions();
  const cellSteps = useMemo(() => steps[parent], [steps, parent]);
  const stepLoad = projectionLoads[buildProjectionRequestKey("steps", parent)];

  useEffect(() => {
    if (_id && !cellSteps && !stepLoad) loadSteps(parent);
  }, [_id, parent, cellSteps, stepLoad, loadSteps]);

  return (
    <>
      <ProjectionLoadState
        level="steps"
        parent={parent}
        parentLabel={parentLabel}
        isMissing={!cellSteps}
        onRetry={() => loadSteps(parent)}
        focusTargetId={containerId}
        showErrorCode
      />
      {cellSteps?.map((item) => (
        <AccordionItem
          key={item.wbs_code_id}
          item={item}
          type="step"
          typeTitle="Etapa"
          ChildAccordionComponent={SubstepAccordion}
          filters={filters}
          path={path}
        />
      ))}
    </>
  );
};

export default StepAccordion;
